import React, { Component } from 'react';
import DeviceData from 'drivers/deviceData';
import Route from 'enum/route.enum';
import { Navigate } from 'react-router-dom';
import { Container, Header } from 'components/styles/Common.styled';

import BackCursor from 'components/common/nav/backCursor';

class Netflix extends Component {
  constructor(props) {
    super(props);
    this.state = {
      redirectBack: false,
    };
    this.onKeyPress = this.onKeyPress.bind(this);
  }

  async componentDidMount() {
    window.addEventListener('keydown', this.onKeyPress);
    DeviceData.launchNetflix();
    this.setState({
      redirectBack: true,
    });
  }

  componentWillUnmount() {
    window.removeEventListener('keydown', this.onKeyPress);
    this.setState = (state, callback) => {
      return;
    };
  }

  async onKeyPress(event) {
    const tvKeyControls = await DeviceData.getTVControl();

    switch (event.keyCode) {
      case tvKeyControls.KEY_BACK:
        this.setState({
          redirectBack: true,
        });
        event.preventDefault();
        break;

      default:
        break;
    }
  }

  render() {
    if (this.state.redirectBack) {
      return <Navigate to={Route.route.LANDING} />;
    }
    return (
      <div>
        <Header></Header>
        <BackCursor></BackCursor>
        <Container></Container>
      </div>
    );
  }
}

export default Netflix;
